


































































import { Component, Prop, Vue } from 'vue-property-decorator'
import AppForm from '@core/components/AppForm.vue'
import AppDatatable from '@core/components/AppDatatable.vue'
import AppDialog from '@core/components/AppDialog.vue'
import { CommissionRecordDTO } from '../api'
import { FormStructure } from '@master/model/structure/FormStructure'
import { startCase } from 'lodash/fp'
import moment from 'moment'
import { IProjectSettings } from '@master/config/IProjectSettings'
import { inject } from 'inversify-props'
import { GetPaymentModeNiceName, GetPremiumType } from '@master/model/options/FrequencyOptions'
import dayjs from 'dayjs'
import { GetCommissionType, GetPremiumYear } from '@master/util/commission-record-calculation'
@Component({
  components: {
    AppDatatable,
    AppForm,
    AppDialog
  }
})
export default class CommissionDetailsDialogComponent extends Vue {
  @Prop({ default: null }) selectedDetail: CommissionRecordDTO

  @inject()
  projectSettings: IProjectSettings

  get commissionDetailsStructure () {
    const structure = [] as any
    for (const key in this.selectedDetail) {
      if (['pky', 'keyword', 'emit', 'ctm', 'utm'].includes(key) || key.toLowerCase().includes('oid')) {
        continue
      }

      if (key === 'remunerationType') {
        structure.push({
          label: startCase(key),
          key,
          options: [
            { label: '', value: undefined },
            { label: 'Commission', value: 0 },
            { label: 'Trailer Fee', value: 1 },
            { label: 'Wrap Fee', value: 2 }
          ],
          disabled: true
        })
      } else {
        structure.push({
          label: startCase(key),
          key,
          disabled: true
        })
      }
    }
    return structure
  }

  get policyDetailsStructureV2 (): FormStructure<CommissionRecordDTO> {
    return [
      {
        label: 'Remuneration Type',
        key: 'remunerationType',
        options: [
          { label: '', value: undefined },
          { label: 'Commission', value: 0 },
          { label: 'Trailer Fee', value: 1 },
          { label: 'Wrap Fee', value: 2 }
        ],
        disabled: true
      },
      {
        label: 'Policy Number',
        key: 'policyNumber',
        disabled: true
      },
      {
        label: 'Product Name',
        key: 'productName',
        disabled: true
      },
      {
        label: 'Adviser Code',
        key: 'advCode',
        disabled: true
      },
      {
        label: 'Adviser Name',
        key: 'advName',
        disabled: true
      },
      {
        label: 'Client Name',
        key: 'clientName',
        disabled: true
      },
      {
        label: 'Premium Amount',
        key: 'premiumAmt',
        disabled: true
      },
      {
        label: 'Gross Commission Amount',
        key: 'commissionAmt',
        disabled: true
      },
      {
        label: 'OR Commission Amount',
        key: 'orCommissionAmt',
        disabled: true
      },
      {
        label: 'Principal',
        key: 'principal',
        disabled: true
      },
      {
        label: 'Transaction Type',
        key: 'transactionType',
        disabled: true
      },
      {
        label: 'Issued Date',
        key: 'issuedDateMillis',
        disabled: true
      },
      {
        label: 'Paid To Date/Due Date',
        key: 'paidToDate',
        disabled: true
      },
      {
        label: 'Payment Mode',
        model: {
          get: () => GetPaymentModeNiceName(this.selectedDetail.payMode),
          set: () => { return null }
        },
        disabled: true
      },
      {
        label: 'Commission Type',
        model: {
          get: () => GetCommissionType(this.selectedDetail.paidToDate, this.selectedDetail.issuedDateMillis),
          set: () => { return null }
        },
        disabled: true
      },
      {
        label: 'Premium Type',
        model: {
          get: () => GetPremiumType(this.selectedDetail.payMode),
          set: () => { return null }
        },
        disabled: true
      },
      {
        label: 'Premium Year',
        model: {
          get: () => GetPremiumYear(this.selectedDetail.paidToDate, this.selectedDetail.issuedDateMillis),
          set: () => { return null }
        },
        disabled: true
      },
      {
        label: 'Payment Date',
        key: 'paymentDateMillis',
        disabled: true
      },
      {
        label: 'Statement Date',
        key: 'statementDateMillis',
        disabled: true
      },
      {
        label: 'Remark',
        key: 'remark',
        disabled: true
      },
      {
        label: 'Paid',
        key: 'paid',
        disabled: true
      }
    ]
  }

  get policyDetailsStructure (): FormStructure<CommissionRecordDTO> {
    const keys = ['policyNumber', 'productName', 'advCode', 'advName', 'clientName', 'premiumAmt', 'commissionAmt', 'orCommissionAmt', 'principal', 'remunerationType', 'transactionType', 'issuedDateMillis', 'dueDateMillis', 'paymentMode', 'remark', 'paymentDateMillis', 'statementDateMillis', 'paid']
    return this.commissionDetailsStructure.filter(structure => keys.includes(structure.key))
  }

  get servicingStructure (): FormStructure<CommissionRecordDTO> {
    const keys = ['introducerFullname', 'introducerComPct', 'introducerComAmt', 'vestingOid', 'vestingFullname', 'vestingComPct', 'vestingComAmt', 'servicingOid', 'servicingFullname', 'servicingComPct', 'servicingComAmt', 'bscClawbackPct', 'clientRebatePct', 'clientRebateAmt', 'level1BscClawbackAmt', 'level2BscClawbackAmt', 'level3BscClawbackAmt', 'level4BscClawbackAmt', 'totalBscClawbackAmt']
    return this.commissionDetailsStructure.filter(structure => keys.includes(structure.key))
  }

  get payoutStructure (): FormStructure<CommissionRecordDTO> {
    return [
      {
        label: 'Level 1 Com Payout',
        key: 'level1ComPayout',
        disabled: true
      },
      {
        label: 'Level 2 Com Payout',
        key: 'level2ComPayout',
        disabled: true
      },
      {
        label: 'Level 3 Com Payout',
        key: 'level3ComPayout',
        disabled: true
      },
      {
        label: 'Level 4 Com Payout',
        key: 'level4ComPayout',
        disabled: true
      },
      {
        label: 'Service Charge',
        key: 'serviceChargePayout',
        disabled: true
      },
      {
        label: 'Group ID',
        key: 'groupId',
        disabled: true
      }
    ]
  }

  get performanceServiceChargeStructure (): FormStructure<CommissionRecordDTO> {
    return [
      {
        label: 'Performance Bonus',
        key: 'performanceBonusPayout',
        disabled: true
      },
      {
        label: 'Profit Sharing',
        key: 'profitSharingRpPayout',
        disabled: true
      }
    ]
  }

  get discrepancyStructure (): FormStructure<CommissionRecordDTO> {
    const keys = ['discrepancy']
    return this.commissionDetailsStructure.filter(structure => keys.includes(structure.key))
  }
}
